import React, { useState ,useContext } from 'react'
import {useNavigate , useLocation } from 'react-router-dom';
import Context  from '../Context/Context';
import Language  from '../Context/Language';

export default function MobileHeaderPanel() {
    const navigate = useNavigate();
    const data = useContext(Context)
    const location = useLocation();
    const datalang = useContext(Language)
   
    const funcOverview=()=>{
      sessionStorage.setItem("left-menu",false)
      navigate(`/Overview/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/${sessionStorage.getItem("lang")}`)
    }

    const funch2h=()=>{
      sessionStorage.setItem("left-menu",false)
      navigate(`/h2h/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/${sessionStorage.getItem("lang")}`)
    }

    const funcFixture=()=>{
      sessionStorage.setItem("left-menu",false)
      navigate(`/Fixture/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/${sessionStorage.getItem("lang")}`)
    }

    const funcTable=()=>{
      sessionStorage.setItem("left-menu",false)
      navigate(`/Table/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/${sessionStorage.getItem("lang")}`)
    }


    const funcTeam=()=>{
      sessionStorage.setItem("left-menu",false)
      navigate(`/Team/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/${sessionStorage.getItem("lang")}`)
    }

    const Info=()=>{
      sessionStorage.setItem("left-menu",false)
      navigate(`/Info/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/${sessionStorage.getItem("lang")}`)
    }



    const funcArchive=()=>{
      sessionStorage.setItem("left-menu",false)
      navigate(`/Tracker/${location.pathname.split("/")[2]}/${location.pathname.split("/")[3]}/${location.pathname.split("/")[4]}/${location.pathname.split("/")[5]}/${sessionStorage.getItem("lang")}`)
    }




      
  return (
    <div className='MobileHeaderPanelContainer'>
         <div className='MobileHeaderContainer'>
            <div onClick={funcOverview} className='headerAreaMobilePanel'>
                   <div onClick={(() => data.setmobilHeaderPanel(false))}  id='Overview'  className='headertext'><div className='HeaderMobilPanelText'><img width={20} height={20} src='/paper.png'></img><div>{datalang[sessionStorage.getItem("lang")].Overview}</div></div></div>
                </div>
                <div  onClick={funch2h} className='headerAreaMobilePanel'>
                  <div onClick={(() => data.setmobilHeaderPanel(false))} id='#HeadtoHead' className='headertext'><div className='HeaderMobilPanelText'><img width={18} height={18} src='/h2h.png'></img><div>{datalang[sessionStorage.getItem("lang")].h2h}</div></div></div>
                </div>
                <div  onClick={funcFixture} className='headerAreaMobilePanel'>
                   <div onClick={(() => data.setmobilHeaderPanel(false))} id='Fixtures' className='headertext'><div className='HeaderMobilPanelText'><img width={15} height={18} src='/calendar.png'></img><div>{datalang[sessionStorage.getItem("lang")].Fixtures}</div></div></div>
                </div>
                {/* <div  onClick={Info} className='headerAreaMobilePanel'>
                   <div onClick={(() => data.setmobilHeaderPanel(false))} id='Fixtures' className='headertext'><div className='HeaderMobilPanelText'><img width={15} height={18} src='/information.png'></img><div>{datalang[sessionStorage.getItem("lang")].Information}</div></div></div>
                </div> */}
                {/* <div  onClick={funcTable} className='headerAreaMobilePanel'>
                   <div onClick={(() => data.setmobilHeaderPanel(false))} id='Tables' className='headertext'><div className='HeaderMobilPanelText'>Tables</div></div>
                </div> */}
                {/* <div  onClick={funcTeam} className='headerAreaMobilePanel'>
                   <div onClick={(() => data.setmobilHeaderPanel(false))} id='Teams' className='headertext'><div className='HeaderMobilPanelText'><img width={19} height={19} src='/jersey.png'></img><div>Teams</div></div></div>
                </div> */}
                {/* <div  onClick={funcArchive} className='headerAreaMobilePanel'>
                  <div onClick={(() => data.setmobilHeaderPanel(false))} id='Archive' className='headertext'><div className='HeaderMobilPanelText'><img width={16} height={18} src='/archive.png'></img><div>Tracker</div></div></div>
                </div> */}
           </div>
    </div>
  )
}
